'use client';

import { c as _c } from "react/compiler-runtime";
import { Box } from '@mantine/core';
import Logo from '@/assets/logo.svg';
import s from './frachter-logo.module.scss';
export const FrachterLogo = t0 => {
  const $ = _c(5);
  const {
    size: t1
  } = t0;
  const size = t1 === undefined ? 36 : t1;
  let t2;
  if ($[0] !== size) {
    t2 = {
      height: size
    };
    $[0] = size;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Logo />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <Box className={s.root} style={t2}>{t3}</Box>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};